export default {
      id: "minsky-logo-usage",
      viewBox: "0 0 132 66",
      url: "../../assets/" + "sprite.svg#minsky-logo-usage",
      toString: function () {
        return this.url;
      }
    }